export enum RessourcesPath {
    ID_RESSOURCE_PARAM_MAP = 'idRessource',
    LISTE = '',
    EDITION = 'edition-ressource',
    EDITION_GENERAL = 'general',
    CREATION = 'creation-ressource',
    PLANNING = 'planning',
  }